(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-si-shop-filters]').forEach((panel) => {
      if (panel.dataset.siInitialized === 'true') return;
      panel.dataset.siInitialized = 'true';

      const page = panel.closest('.si-collection-page');
      const cards = Array.from(page?.querySelectorAll('[data-si-product-card]') || []);
      const controls = Array.from(panel.querySelectorAll('input[type="checkbox"]'));
      const clearButtons = Array.from(page?.querySelectorAll('[data-si-filter-clear]') || []);
      const status = panel.querySelector('[data-si-filter-status]');
      const mastheadCount = page?.querySelector('[data-si-shop-count]');
      const emptyState = page?.querySelector('[data-si-filter-empty]');
      const toolsForm = page?.querySelector('.si-collection-tools');
      const params = new URLSearchParams(window.location.search);

      const selectedFromUrl = (name) => params.getAll(name).flatMap((value) => value.split(',')).filter(Boolean);
      const selectedBrands = selectedFromUrl('brand');
      const selectedCategories = selectedFromUrl('category');

      controls.forEach((control) => {
        const selected = control.name === 'brand' ? selectedBrands : selectedCategories;
        control.checked = selected.includes(control.value);
      });

      const selectedValues = (name) => controls.filter((control) => control.name === name && control.checked).map((control) => control.value);

      const syncToolsForm = (brands, categories) => {
        if (!toolsForm) return;
        toolsForm.querySelectorAll('[data-si-filter-state]').forEach((input) => input.remove());
        [...brands.map((value) => ['brand', value]), ...categories.map((value) => ['category', value])].forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          input.dataset.siFilterState = '';
          toolsForm.appendChild(input);
        });
      };

      const updateUrl = (brands, categories) => {
        const next = new URL(window.location.href);
        next.searchParams.delete('brand');
        next.searchParams.delete('category');
        next.searchParams.delete('page');
        brands.forEach((value) => next.searchParams.append('brand', value));
        categories.forEach((value) => next.searchParams.append('category', value));
        window.history.replaceState({}, '', next);
      };

      const applyFilters = ({ writeUrl = false } = {}) => {
        const brands = selectedValues('brand');
        const categories = selectedValues('category');
        let visibleCount = 0;

        cards.forEach((card) => {
          const cardCategories = (card.dataset.siCategories || '').split(/\s+/).filter(Boolean);
          const matchesBrand = brands.length === 0 || brands.includes(card.dataset.siBrand || '');
          const matchesCategory = categories.length === 0 || categories.some((category) => cardCategories.includes(category));
          const isVisible = matchesBrand && matchesCategory;
          card.hidden = !isVisible;
          card.classList.toggle('is-filtered-out', !isVisible);
          if (isVisible) visibleCount += 1;
        });

        controls.forEach((control) => control.closest('label')?.classList.toggle('is-selected', control.checked));
        const countLabel = mastheadCount?.dataset.siCountLabel || 'styles';
        if (status) status.textContent = `${visibleCount} ${countLabel}`;
        if (mastheadCount) mastheadCount.textContent = `${visibleCount} ${countLabel}`;
        if (emptyState) emptyState.hidden = visibleCount !== 0;
        clearButtons.forEach((button) => button.setAttribute('aria-pressed', String(brands.length === 0 && categories.length === 0)));
        syncToolsForm(brands, categories);
        if (writeUrl) updateUrl(brands, categories);
      };

      controls.forEach((control) => control.addEventListener('change', () => applyFilters({ writeUrl: true })));
      clearButtons.forEach((button) => button.addEventListener('click', () => {
        controls.forEach((control) => { control.checked = false; });
        applyFilters({ writeUrl: true });
      }));

      applyFilters();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
